import { createPinia, defineStore } from "pinia";

export const useInvitationStore = defineStore("invitation", {
  state: () => ({
    client: {},
    gallery: [],
    story: [],
    ucapan: [],
    config: {},
    guest: null,
    fallbackName: "",
    _galleryPicks: [null, null, null],
  }),
  getters: {
    randomGalleryPicks: (state) => state._galleryPicks,
  },
  actions: {
    setData(data) {
      this.client = data || {};
      this.gallery = data?.gallery || [];
      this.story = data?.story || [];
      this.ucapan = data?.ucapan || [];
      this.config = data?.config?.[0] || {};
      this._pickRandomGallery();
    },
    _pickRandomGallery() {
      const arr = this.gallery;
      if (!arr || arr.length === 0) { this._galleryPicks = [null, null, null]; return; }
      const shuffled = [...arr].sort(() => Math.random() - 0.5);
      this._galleryPicks = [
        shuffled[0]?.file || null,
        shuffled[1]?.file || null,
        shuffled[2]?.file || null,
      ];
    },
  },
});

const createStore = () => createPinia();

export default createStore;
